module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('fullpage', {
    staticClass: "fullpage-demo",
    attrs: {
      "drag": "",
      "start": 0,
      "duration": 100
    },
    on: {
      "on-change": _vm.onChange,
      "on-before-change": _vm.onBeforeChange,
      "on-after-change": _vm.onAfterChange
    }
  }, [_c('div', [_c('div', [_vm._v("1")])]), _vm._v(" "), _c('div', [_c('div', [_vm._v("2")])]), _vm._v(" "), _c('div', [_c('div', [_vm._v("3")])]), _vm._v(" "), _c('div', [_c('div', [_vm._v("4")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-95359386"}!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vux/src/components/fullpage/DemoBasic.vue
// module id = 539
// module chunks = 4